import { SearchTerm } from "./SearchTerm";

const PresetParameterSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        translationKey: "name",
        searchOnName: "trnName",
    },
    // {
    //     heading: "Type",
    //     accessor: "type",
    //     translationKey: "type"
    //     // searchOnName: "setting.settingType.nameOriginal",
    // },
    // {
    //     heading: "Used By",
    //     accessor: "usedBy",
    //     translationKey: "usedBy"
    //     // searchOnName: "setting.sDist",
    // },
    // {
    //     heading: "Input/Port No.",
    //     accessor: "inputNo",
    //     // searchOnName: "data.diNo",
    // }
];

export default PresetParameterSearch;
